import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CalculationResult from './CalculationResult';
import AgentResult from './AgentResult';
import CurrencyOption from './CurrencyOption';
import SearchBar from './searchBar/SearchBar';
import CalculationInfo from './CalculationInfo'; 
import axios from '../../../axios/axios';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class Calculator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            countryFromISO: '',
            countryToISO: '',
            fromCountries: [],
            toCountries: [],
            allTariffs: [],
            fromCurrency: [],
            toCurrency: [],
            fromCurrencySelected: '',
            toCurrencySelected: '',
            isToCountryDisabled: true,
            isFromCurrencyDisabled: true,
            isFromCurrencySelectDisabled: true,
            isToCurrencySelectDisabled: true,
            isToCurrencyDisabled: true,
            isConditionsDisabled: true,
            isConditionsCashDisabled: true,
            isConditionsCardDisabled: true,
            conditionSelected: '',
            isTransferAmountDisabled: true,
            amountValues: {},
            isShowMaxAmountMessage: false,
            isShowMinAmountMessage: false,
            amountInput: '',
            isAmountInputValid: true,
            isCountButtonDisabled: true,
            calculationResult: '',
            agentResult: '',
            filteredTariffs: []
        }

        this.calcutationInfoRef = React.createRef();
    }

    getContriesFromList = (countries) => {
        this.setState({...this.state, fromCountries: countries, loading: false})
    }

    componentDidMount() {
        this.getTariffsFrom();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.key !== prevProps.location.key && this.props.location.hash === '#howToSend') {
            window.scrollTo(0, this.calcutationInfoRef.current.offsetTop);
        }
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getTariffsFrom();
        }
    }

    getTariffsFrom = () => {
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        this.setState({
                loading: true, 
                countryFromISO: '',
                countryToISO: '',
                fromCountries: [],
                toCountries: [],
                allTariffs: [],
                fromCurrency: [],
                toCurrency: [],
                fromCurrencySelected: '',
                toCurrencySelected: '',
                isToCountryDisabled: true,
                isFromCurrencyDisabled: true,
                isFromCurrencySelectDisabled: true,
                isToCurrencySelectDisabled: true,
                isToCurrencyDisabled: true,
                isConditionsDisabled: true,
                isConditionsCashDisabled: true,
                isConditionsCardDisabled: true,
                conditionSelected: '',
                isTransferAmountDisabled: true,
                amountValues: {},
                isShowMaxAmountMessage: false,
                isShowMinAmountMessage: false,
                amountInput: '',
                isAmountInputValid: true,
                isCountButtonDisabled: true,
                calculationResult: '',
                agentResult: '',
                filteredTariffs: [] 
            }, () => {
            axios.get(`/api/welsend/public/tariffs/calculator/countries/from`)
            .then(res => {
                this.getContriesFromList(res.data, 'from');
                this.scrollToHowToSend();
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    scrollToHowToSend = () => {
        if (this.props.location.state.howToSend) {
            window.scrollTo(0, this.calcutationInfoRef.current.offsetTop);
        }
    }

    getCountryISO = (ISO, direction) => {
        switch(direction) {
            case 'from': {
                     if (!ISO && !this.state.countryToISO) {
                        this.setState({...this.state, countryFromISO: '',
                                     isToCountryDisabled: true,
                                     toCountries: [],
                                     fromCurrency: [],
                                     toCurrency: [],
                                     isFromCurrencyDisabled: true,
                                     isFromCurrencySelectDisabled: true,
                                     isToCurrencyDisabled: true,
                                     isConditionsDisabled: true,
                                     isConditionsCashDisabled: true,
                                     isShowMaxAmountMessage: false,
                                     isShowMinAmountMessage: false,
                                     isAmountInputValid: true,
                                     isTransferAmountDisabled: true,
                                     isConditionsCardDisabled: true,
                                     isCountButtonDisabled: true, 
                                     conditionSelected: '',
                                     calculationResult: '',
                                     agentResult: ''}
                    )} else if (ISO && !this.state.countryToISO) {
                        this.setState({...this.state, countryFromISO: ISO, 
                                                     isToCountryDisabled: false,
                                                     conditionSelected: '',
                                                     isCountButtonDisabled: true,
                                                     isFromCurrencyDisabled: true});
                        this.getContriesToList(ISO, this.state.countryToISO);
                    }  else if  (ISO && this.state.countryToISO) {
                        this.getContriesToList(ISO, this.state.countryToISO);
                        this.setState({...this.state, 
                                        countryFromISO: ISO, 
                                        isToCountryDisabled: false, 
                                        isFromCurrencyDisabled: true},
                                         () => { this.getAllTariffs();
                        })
                    } else if (!ISO && this.state.countryToISO) {
                        this.setState({...this.state, countryFromISO: '',
                                     isToCountryDisabled: true,
                                     toCountries: [],
                                     isFromCurrencyDisabled: true,
                                     isFromCurrencySelectDisabled: true,
                                     isToCurrencyDisabled: true,
                                     isConditionsDisabled: true,
                                     isConditionsCashDisabled: true,
                                     isTransferAmountDisabled: true,
                                     conditionSelected: '',
                                     isConditionsCardDisabled: true,
                                     isShowMaxAmountMessage: false,
                                     isShowMinAmountMessage: false,
                                     isAmountInputValid: true,
                                     isCountButtonDisabled: true,
                                     calculationResult: '',
                                     agentResult: ''})
                    }
                break;
            }
            case 'to': {
                if (!ISO) {
                    this.setState({...this.state,
                                     isFromCurrencyDisabled: true,
                                     isFromCurrencySelectDisabled: true,
                                     isToCurrencyDisabled: true,
                                     conditionSelected: '',
                                     isConditionsDisabled: true,
                                     isConditionsCashDisabled: true,
                                     isConditionsCardDisabled: true,
                                     isShowMaxAmountMessage: false,
                                     isShowMinAmountMessage: false,
                                     isAmountInputValid: true,
                                     isTransferAmountDisabled: true,
                                     isCountButtonDisabled: true,
                                     calculationResult: '',
                                     agentResult: ''})
                } else if (ISO) {
                    this.setState({...this.state, countryToISO: ISO, isFromCurrencyDisabled: false}, 
                        () => {this.getAllTariffs()});
                }
                break;
            }
        }
    }

    getContriesToList(fromISO, toISO) {
        axios.get(`/api/welsend/public/tariffs/calculator/countries/to?fromCountryIso3=${fromISO}`)
        .then(res => {
            this.setState({...this.state, toCountries: res.data}, () => {
                if(toISO) {
                    const isToISOexist = this.state.toCountries.filter(country => country.countryIso3 === toISO);
                    isToISOexist.length === 0 ? this.setState({...this.state, 
                                                                countryToISO: "", 
                                                                fromCurrency: [],
                                                                toCurrency: [],
                                                                isCountButtonDisabled: true,
                                                                isConditionsDisabled: true,
                                                                isConditionsCashDisabled: true,
                                                                isConditionsCardDisabled: true}) :  ""}
                                                            });
        })
        .catch((error =>  {
            console.log(error);
        }))
    }

    getAllTariffs() {
        axios.get(`/api/welsend/public/tariffs/calculator?fromCountryIso3=${this.state.countryFromISO}&toCountryIso3=${this.state.countryToISO}`)
        .then(res => {
            this.setState({...this.state, allTariffs: res.data}, () => this.getFromCurrency())
        })
        .catch((error =>  {
            console.log(error);
        }))
    }

    handleFromCurrencyChange = (event) => {
        this.setState({...this.state, 
                        fromCurrencySelected: event.target.value, 
                        isConditionsDisabled: false, 
                        isCountButtonDisabled: true,
                        conditionSelected: '',
                        calculationResult: '',
                        agentResult: ''
                    }, 
                        () => {this.getCondition()})
    }

    getFromCurrency() {
        let setCurrency = new Set();
        this.state.allTariffs.forEach(tariff => setCurrency.add(tariff.fromCurrency));
        let fromCurrency = (Array.from(setCurrency)).map(currency => {
            return <CurrencyOption currency={currency} key={currency}/>
        })
        if (fromCurrency.length === 1) {
            this.setState({...this.state, fromCurrency: fromCurrency, 
                            isFromCurrencySelectDisabled: true,
                            fromCurrencySelected: fromCurrency[0].props.currency,
                            isConditionsDisabled: false}, () =>
                            {this.getCondition()})
        } else if (fromCurrency.length === 0) {
            this.setState({...this.state, isFromCurrencyDisabled: true})
        } else {
            this.setState({...this.state, 
                            fromCurrency: fromCurrency, 
                            isFromCurrencySelectDisabled: false, 
                            fromCurrencySelected: fromCurrency[0].props.currency,
                            isConditionsDisabled: this.state.fromCurrencySelected.length > 0 ? false : true,
                            isFromCurrencyDisabled: false}, () => {
                                if (this.state.fromCurrencySelected.length) {
                                    this.getCondition()
                                } 
                            })
        }
    }

    getCondition() { 
        const allTariffsFromCurrencySelected = this.getAllTariffsFromCurrencySelected();
        let setConditions = new Set();
        allTariffsFromCurrencySelected.forEach(tariff => setConditions.add(tariff.fromCondition));

        const setConditionsArray = Array.from(setConditions);
        
        if (setConditionsArray.length === 1) {
            setConditionsArray.forEach(condition => {
                if (condition === 'Cash') {
                    this.setConditionCash(allTariffsFromCurrencySelected);
                } else if (condition === 'Card') {
                    this.setConditionCard(allTariffsFromCurrencySelected);
                }
            })
        } else if(setConditionsArray.length === 2) {
            this.setState({...this.state, isConditionsDisabled: false, 
                                          isConditionsCashDisabled: false,
                                          isConditionsCardDisabled: false
                                         })
        }

    }

    handleCondition = (e) => {
       const condition = e.currentTarget.id;
       const allTariffsFromCurrencySelected = this.getAllTariffsFromCurrencySelected();
       this.setCondition(condition, allTariffsFromCurrencySelected) 
    }

    getAllTariffsFromCurrencySelected = () => {
        const allTariffsFromCurrencySelected = this.state.allTariffs.filter(tariff => 
            tariff.fromCurrency === this.state.fromCurrencySelected);
        return allTariffsFromCurrencySelected;
    }

    setCondition = (condition, allTariffsFromCurrencySelected) => {
        const allTariffsByConditionSelected = [];

        allTariffsFromCurrencySelected.forEach(tariff => {
            if (tariff.fromCondition === condition) {
                allTariffsByConditionSelected.push(tariff);
            }
        })

        switch(condition) {
            case "Cash": {
                this.setConditionCash(allTariffsByConditionSelected);
                break;
            }
            case "Card": {
                this.setConditionCard(allTariffsByConditionSelected);
                break;
            }
        }
    }

    setConditionCash = (tariffs) => {
        this.setState({...this.state, isConditionsCashDisabled: false,
            isConditionsDisabled: false,
            conditionSelected: 'Cash',
            agentResult: '',
            isToCurrencyDisabled: false}, () =>
                this.getToCurrency(tariffs, 'Cash'))
    }

    setConditionCard = (tariffs) => {
        const allAgents = new Set();
            tariffs.forEach(tariff => {
                if(tariff.onlineTransfersAgentDto && !allAgents.has(JSON.stringify(tariff.onlineTransfersAgentDto))) {
                    allAgents.add(JSON.stringify(tariff.onlineTransfersAgentDto));
                }
            })
            const allAgentsParsed = Array.from(allAgents).map(agent => JSON.parse(agent));
                    this.setState({...this.state, 
                                    isConditionsCardDisabled: false, 
                                    isToCurrencyDisabled: true,
                                    isConditionsDisabled: false,
                                    amountInput: '',
                                    isShowMaxAmountMessage: false,
                                    isShowMinAmountMessage: false,
                                    conditionSelected: 'Card',
                                    calculationResult: '',
                                    agentResult: allAgentsParsed
                                }, () =>
                    this.getToCurrency(tariffs, 'Card'))
    }

    getToCurrency(tariffs, condition) {
        let setToCurrency = new Set();
        tariffs.forEach(tariff => setToCurrency.add(tariff.toCurrency))
        let toCurrency = (Array.from(setToCurrency)).map(currency => {
            return <CurrencyOption currency={currency} key={currency}/>
        })

        if (toCurrency.length === 1) {
            this.setState({...this.state, 
                toCurrency: toCurrency,
                isToCurrencySelectDisabled: true,
                isToCurrencyDisabled: true,
                toCurrencySelected: toCurrency[0].props.currency,
                isTransferAmountDisabled: condition === "Cash" ? false : true,
                filteredTariffs: tariffs,
                isCountButtonDisabled: this.state.amountInput.length <= 0
            }, () => this.getAmountValues(tariffs))
        }  else if (toCurrency.length === 0) {
            this.setState({...this.state, isToCurrencyDisabled: true})
        } else {
            this.setState({...this.state, 
                toCurrency: toCurrency,
                toCurrencySelected: '',
                filteredTariffs: tariffs,
                isTransferAmountDisabled: condition === 'Cash' ? false : true,
            }, () => this.getAmountValues(tariffs))
        }
    }

    validAmountField() {
        this.handleAmountValues(null, this.state.amountInput);
        const minTransferAmount = this.state.amountValues.minTransferAmount < 1 ? 
                                   1 : this.state.amountValues.minTransferAmount;
        const data = {}

        if (this.state.amountInput.length > 0) {
            if (this.state.amountInput < minTransferAmount 
                && this.state.amountInput.length > 0) {
                data.isShowMinAmountMessage = true
                data.isAmountInputValid =false
                data.isCountButtonDisabled = true
                data.calculationResult = ''
            } else if (this.state.amountInput < minTransferAmount 
                && this.state.amountInput.length === 0) {
                data.isShowMinAmountMessage = false
                data.isAmountInputValid = true
            } else if (this.state.amountInput > minTransferAmount && (this.state.amountInput < this.state.amountValues.maxTransferAmount)) {
                data.isShowMaxAmountMessage = false
                data.isShowMinAmountMessage = false
                data.isAmountInputValid = true
            } else if (this.state.amountValues.maxTransferAmount && 
                       this.state.amountInput > this.state.amountValues.maxTransferAmount) {
                data.isShowMaxAmountMessage = true
                data.isAmountInputValid = false
                data.isCountButtonDisabled = true
                data.calculationResult = ''
            }  
            this.setState({...this.state, ...data})
        }
    }

    getAmountValues(tariffs) {
        let amountValues = {
            minTransferAmount: '',
            maxTransferAmount: ''
        }
        
        tariffs.forEach(tariffs => {
            if (amountValues.minTransferAmount === '') {
                amountValues = {...amountValues, minTransferAmount: tariffs.minTransferAmount}
            } else if (amountValues.minTransferAmount !== ''
                && amountValues.minTransferAmount > tariffs.minTransferAmount) {
                amountValues = {...amountValues, minTransferAmount: tariffs.minTransferAmount}
            } 
        } )

        tariffs.forEach(tariffs => {
            if (amountValues.maxTransferAmount === '') {
                amountValues = {...amountValues, maxTransferAmount: tariffs.maxTransferAmount}
            } else if (amountValues.maxTransferAmount !== '' 
                && amountValues.maxTransferAmount < tariffs.maxTransferAmount) {
                amountValues = {...amountValues, maxTransferAmount: tariffs.maxTransferAmount}
            } 
        } )

        this.setState({...this.state, amountValues: amountValues}, () => this.validAmountField())
    }

    handleAmountValues = (event, currentValue) => {
        const value = !event === false ? event.target.value : currentValue;
        const minTransferAmount = this.state.amountValues.minTransferAmount < 1 ?
                                   1 : this.state.amountValues.minTransferAmount;

        const data = {}

        if (value < minTransferAmount && value.length > 0) {
            data.isShowMinAmountMessage = true
            data.isCountButtonDisabled = true
            data.calculationResult = ''
            data.isAmountInputValid =false
        } else if (value < minTransferAmount && value.length === 0) {
            data.isShowMinAmountMessage = false
            data.isAmountInputValid = true
        } else if (this.state.amountValues.maxTransferAmount && value >= minTransferAmount
            && value <= this.state.amountValues.maxTransferAmount) {
            data.isShowMaxAmountMessage = false
            data.isShowMinAmountMessage = false
            data.isAmountInputValid = true
        } else if (this.state.amountValues.maxTransferAmount && value > this.state.amountValues.maxTransferAmount){
            data.isShowMaxAmountMessage = true
            data.isAmountInputValid = false
            data.calculationResult = ''
        } else if (value >= minTransferAmount) {
            data.isShowMaxAmountMessage = false
            data.isShowMinAmountMessage = false
            data.isAmountInputValid = true
        } 

        const re = /^[0-9 .]+$/;
        if (value.length > 0 && !data.isAmountInputValid) {
            data.isCountButtonDisabled = true
            if(re.test(value)) {
                data.amountInput = value
            }
        } else if (value.length > 0 && data.isAmountInputValid) {
            data.isCountButtonDisabled = false
            if(re.test(value)) {
                data.amountInput = value
            }
        } else if (value.length == 0) {
            data.isCountButtonDisabled = true
            data.calculationResult = ''
            data.amountInput = ''
        }
        this.setState({...this.state, ...data})
    }

    getCountResult = () => {
        let result = {
            fromCurrencySelected: this.state.fromCurrencySelected,
            toCurrencySelected: this.state.toCurrencySelected,
            amountInput: this.state.amountInput,
        }
        const allTariffsByCurrency = this.state.filteredTariffs.filter(tariff => 
                            tariff.fromCurrency === this.state.fromCurrencySelected)
        
        const allTariffsByMinValue = allTariffsByCurrency.filter(tariff => 
            this.state.amountInput  >= tariff.minTransferAmount || tariff.minTransferAmount === null
        )
        
        const allTariffsByMaxValue = allTariffsByMinValue.filter(tariff => 
            this.state.amountInput <= tariff.maxTransferAmount || tariff.maxTransferAmount === null
        )

        const allTariffsSort = allTariffsByMaxValue.sort((a, b) => {
             if (a.commissionPercent < b.commissionPercent) {
                 return 1;
             } else  if (a.commissionPercent > b.commissionPercent) {
                 return -1;
             } else if (a.commissionPercent === b.commissionPercent) {
                if (a.minCommissionAmountInToCcy < b.minCommissionAmountInToCcy)  {
                    return 1;
                } else {
                    return -1;
                }
             }
        })

        result.filteredTariffs =  allTariffsSort;

        const targetTariff = allTariffsSort[0];

        if (targetTariff.minCommissionAmountInToCcy || targetTariff.commissionPercent) {
            if (targetTariff.minCommissionAmountInToCcy && targetTariff.commissionPercent) {
                result.commissionPercent = Number((targetTariff.commissionPercent * 100).toFixed(2));
                result.minCommissionAmountInToCcy = targetTariff.minCommissionAmountInToCcy;
                result.commissionValueByInput = targetTariff.commissionPercent * result.amountInput;
                result.commissionValue = Number((result.commissionValueByInput > result.minCommissionAmountInToCcy ? 
                                         result.commissionValueByInput : result.minCommissionAmountInToCcy).toFixed(2))
                result.allValueAmount = +result.commissionValue + +result.amountInput;                    
            } else if (!targetTariff.minCommissionAmountInToCcy && targetTariff.commissionPercent) {
                result.commissionPercent = Number((targetTariff.commissionPercent * 100).toFixed(2));
                result.minCommissionAmountInToCcy = targetTariff.minCommissionAmountInToCcy;
                result.commissionValue = Number((targetTariff.commissionPercent * result.amountInput).toFixed(2));
                result.allValueAmount = +result.commissionValue + +result.amountInput; 
            } else if (targetTariff.minCommissionAmountInToCcy && !targetTariff.commissionPercent) {
                result.commissionPercent = '';
                result.minCommissionAmountInToCcy = targetTariff.minCommissionAmountInToCcy;
                result.commissionValue = result.minCommissionAmountInToCcy;
                result.allValueAmount = +result.commissionValue + +result.amountInput; 
            }
            this.setState({...this.state, calculationResult: result})
        } else if (!targetTariff.minCommissionAmountInToCcy
                     && !targetTariff.commissionPercent 
                     && targetTariff.onlineTransfersAgentDto) {
            this.setState({...this.state, agentResult: targetTariff.onlineTransfersAgentDto})                        
        }  
    }

    scrollToInfo = () => {
        window.scrollTo(0, this.calcutationInfoRef.current.offsetTop);
    }

    render() {
        const isFromCurrencyDisabled = this.state.isFromCurrencyDisabled ? 'disabled' : '';
        const isConditionsDisabled = this.state.isConditionsDisabled ? 'disabled' : '';
        const isToCurrencyDisabled = this.state.isToCurrencyDisabled ? 'disabled' : '';
        const isTransferAmountDisabled = this.state.isTransferAmountDisabled ? 'disabled' : '';
        const isToCountryDisabled = this.state.isToCountryDisabled ? 'disabled' : '';
        const isShowMaxAmountMessage = this.state.isShowMaxAmountMessage ? 'show' : '';
        const isShowMinAmountMessage = this.state.isShowMinAmountMessage ? 'show' : '';
        const isAmountInputValid = this.state.isAmountInputValid ? '' : 'error';
        const isCountButtonDisabled = this.state.isCountButtonDisabled ? 'disabled' : '';
        const minTransferAmount = this.state.amountValues.minTransferAmount < 1 ?
                                   1 : this.state.amountValues.minTransferAmount;
        const defaultValue = translateStaticContent('fromCurrencyPlaceholder', 
                                this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);
        const placeholderCountryFrom = translateStaticContent('fromCountryPlaceholder', 
                                            this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);
        const placeholderCountryTo = translateStaticContent('toCountryPlaceholder', 
                                            this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);
        const placeholderSum = translateStaticContent('sumPlaceholder', 
                                            this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc);
        return(
            <div className="container calculator">
                <h1>
                    {translateStaticContent('transferCount', 
                        this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                </h1>
                {this.state.loading ? <Loader /> :
                <div>
                    <div className="section">
                        <div className="section-item">
                            <div className='title'>
                                {translateStaticContent('fromCountryLabel', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            {this.state.fromCountries.length > 0 ? <SearchBar countryISO={this.getCountryISO} 
                                    countries={this.state.fromCountries}
                                    direction={'from'} 
                                    isValid={false}
                                    placeholder={placeholderCountryFrom}
                                    defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                                    activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}/> : ''}
                            
                        </div>
                        <div className={`section-item ${isToCountryDisabled}`}>
                            <div className='title'>
                                {translateStaticContent('toCountryLabel', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            <SearchBar countryISO={this.getCountryISO} 
                                    countries={this.state.toCountries}
                                    countryToISO={this.state.countryToISO}
                                    direction={'to'} 
                                    isValid={false}
                                    isDisabled={isToCountryDisabled}
                                    placeholder={placeholderCountryTo}
                                    defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                                    activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}
                            />
                        </div>
                    </div>
                    <div className="section">
                        <div className={`section-item ${isFromCurrencyDisabled} item-select`}>
                            <div className='title'>
                                {translateStaticContent('fromCurrencyLabel', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            <select name="fromCurrency" id="fromCurrency"
                                    className="select-currency"
                                    value={this.state.fromCurrencySelected}
                                    disabled={this.state.isFromCurrencySelectDisabled}
                                    onChange={this.handleFromCurrencyChange}>
                                    <option value='' disabled>{defaultValue}</option>
                                    {this.state.fromCurrency ? this.state.fromCurrency : ''}
                            </select>
                        </div>
                        <div className={`section-item ${isConditionsDisabled}`}>
                            <div className='title'>
                                {translateStaticContent('conditionLabel', 
                                this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            <div className="buttons">
                                <button disabled={this.state.isConditionsCashDisabled} 
                                        className={this.state.conditionSelected === 'Cash' ? 'cash' : ''}
                                        id='Cash'
                                        onClick={this.handleCondition}>
                                            {translateStaticContent('conditionCash', 
                                            this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                                </button>
                                <button disabled={this.state.isConditionsCardDisabled} 
                                        className={this.state.conditionSelected === 'Card' ? 'card' : ''}
                                        id='Card'
                                        onClick={this.handleCondition}>
                                            {translateStaticContent('conditionCard', 
                                            this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="section">
                        <div className={`section-item ${isToCurrencyDisabled} item-select`}>
                            <div className='title'>
                                {translateStaticContent('toCurrencyLabel', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            <select name="toCurrency" 
                                    id="toCurrency" 
                                    className="select-currency"
                                    disabled={this.state.isToCurrencySelectDisabled}
                                    value={this.state.toCurrencySelected}>
                                    <option value='' disabled>{defaultValue}</option>
                                    {this.state.toCurrency ? this.state.toCurrency : ''}
                            </select>
                        </div>
                        <div className={`section-item ${isTransferAmountDisabled} amount`}>
                            <div className='title'>
                                {translateStaticContent('sumLabel', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                            </div>
                            <input id="amount" type="text" value={this.state.amountInput}
                                className={`amountInput ${isAmountInputValid}`}
                                name="amountValus" placeholder={placeholderSum}
                                onChange={this.handleAmountValues}
                                disabled={this.state.isTransferAmountDisabled}/> 
                            <div className={`maxAmountMessage ${isShowMaxAmountMessage}`}>
                                {translateStaticContent('maxSumMessage', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                                 &nbsp;
                                {this.state.amountValues.maxTransferAmount} {this.state.toCurrencySelected}
                            </div>
                            <div className={`minAmountMessage ${isShowMinAmountMessage}`}>
                                {translateStaticContent('minSumMessage', 
                                    this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                                &nbsp;
                                {minTransferAmount} {this.state.toCurrencySelected}
                            </div>

                        </div>
                    </div>
                    <div className="section">
                        <button className={`count ${isCountButtonDisabled}`} 
                                disabled={`${isCountButtonDisabled}`}
                                onClick={this.getCountResult}>
                                    {translateStaticContent('transferCountBtnCount', 
                                        this.props.defaultStaticContentCalc, this.props.activeLangStaticContentCalc)}
                                </button>
                    </div>
                    <div className="showResult">
                    {this.state.calculationResult ? 
                        <CalculationResult result={this.state.calculationResult} 
                        defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                        activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}
                        countryFromISO={this.state.countryFromISO}
                        countryToISO={this.state.countryToISO}
                        scroll={this.scrollToInfo}/> : ''} 
                    {this.state.agentResult ? 
                        <AgentResult result={this.state.agentResult}
                                     defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                                     activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}/> : '' } 
                    </div>
                    <div ref={this.calcutationInfoRef}>
                        <CalculationInfo defaultStaticContentCalc={this.props.defaultStaticContentCalc}
                                         activeLangStaticContentCalc={this.props.activeLangStaticContentCalc}
                                         defaultStaticContentSend={this.props.defaultStaticContentSend}
                                         activeLangStaticContentSend={this.props.activeLangStaticContentSend}/>
                    </div>
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})

export default connect(mapStateToProps)(Calculator);

Calculator.propTypes = {
    location: PropTypes.object.isRequired,
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentCalc: PropTypes.object,
    activeLangStaticContentCalc: PropTypes.object,
    defaultStaticContentNav: PropTypes.object,
    activeLangStaticContentNav: PropTypes.object,
    defaultStaticContentSend: PropTypes.object,
    activeLangStaticContentSend: PropTypes.object,
}